import ContentTab from "@components/shared/contentTab";
import { useQuery } from "@tanstack/react-query";
import {
    ICategoryPageSharedProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import { GQLUrls } from "@gql/types/gql";
import { resolveURL } from "@lib/sharedUtils";

export default function CategoryTab() {
    const { data: sharedProps } = useQuery<ICategoryPageSharedProps>([
        "categoryPageSharedProps",
    ]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { url } = sharedProps ?? {};

    const contentArr = [
        {
            label: `${translate(
                translations,
                "several_category_mainTab_overview",
            )}`,
            slug: "overview",
            link: `${resolveURL(url as GQLUrls)}`,
        },
        {
            label: `${translate(
                translations,
                "several_category_mainTab_bestOverAll",
            )}`,
            slug: "comparison",
            link: `${resolveURL(url as GQLUrls)}/comparison`,
        },
        {
            label: `${translate(
                translations,
                "several_category_mainTab_compare",
            )}`,
            slug: "compare",
            link: `${resolveURL(url as GQLUrls)}/compare`,
        },
        {
            label: `${translate(
                translations,
                "several_category_mainTab_articles",
            )}`,
            slug: "articles",
            link: `/blog/category${resolveURL(url as GQLUrls)}`,
        },
        // {
        //     label: `${translate(translations, "several_general_newsWord")}`,
        //     slug: "news-articles",
        //     link: `${resolveURL(url as GQLUrls)}/news-articles`,
        // },
    ];

    return <ContentTab contentTab={contentArr} />;
}
